import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
`;

export const Icon = styled.i`
  font-size: 24px;
  color: #f59e0b;
  flex-shrink: 0;
`;
